module.exports = __webpack_public_path__ + "img/slider-image-1.19320f87.png";